/**
 * Company: SPHMedia
 * Description: [Show sticky mybh menu hook]
 */

import { isClientSide } from "@helper/utils";
import { useEffect, useState } from "react";

type useShowStickyMenuData = {
  showStickyMenu: boolean;
};

/**
 * Custom React Hook: useShowStickyMenuHook
 * Description: [Checks non sticky mybh menu on scroll and once invisible, sets true for sticky menu]
 * @param props - The props required by the hook (if any)
 * @returns data - The data returned by the hook
 */
export default function useShowStickyMenu(): useShowStickyMenuData {
  const [showStickyMenu, setShowStickyMenu] = useState(false);

  useEffect(() => {
    if (!isClientSide) return;

    const handleScroll = () => {
      const header = document.getElementById("mybh-header");

      if (!header) return;

      const rect = header.getBoundingClientRect();

      // when header is out of view
      setShowStickyMenu(rect.bottom <= -20);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { showStickyMenu };
}
